// extracted by mini-css-extract-plugin
export var productList = "styles_productList__ALp7Q";
export var shipment = "styles_shipment__sWA0I";